import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    get_meeting,
  add_meeting,
  update_meeting,
  delete_meeting,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
    meetings: [],
    meetinglist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    school_class:"",
    section:"",
    description:"",
    meeting_link:"",
    code:"",
    time_duration:"",
    start_time:"",
    start_date:""
  },
};



// Async Thunks for API Calls
export const fetchmeeting = createAsyncThunk(
  "meeting/fetchmeeting",
  async ({ page, page_size,type,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_meeting(page, page_size,type,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createmeeting = createAsyncThunk(
  "meeting/createmeeting",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_meeting(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatemeeting = createAsyncThunk(
  "meeting/updatemeeting",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_meeting(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletemeeting = createAsyncThunk(
  "meeting/deletemeeting",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_meeting({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// hostel_category Slice
const meetingSlice = createSlice({
  name: 'meetings',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, name,description } = action.payload;
      state.formData = { id, name,description };
    },
    resetFormData(state) {
      state.formData = {
        school_class:"",
        section:"",
        description:"",
        meeting_link:"",
        code:"",
        time_duration:"",
        start_time:"",
        start_date:""
      };
    },
    setmeeting(state, action) {
      state.meeting = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
 
       // Fetch hostel_category
       .addCase(fetchmeeting.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchmeeting.fulfilled, (state, action) => {
        state.loading = false;
        state.meetings = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchmeeting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add hostel_category
      .addCase(createmeeting.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createmeeting.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createmeeting.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
        state.IsEditing = false;
      })
      // Update hostel_category
      .addCase(updatemeeting.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatemeeting.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatemeeting.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete hostel_category
      .addCase(deletemeeting.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletemeeting.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletemeeting.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setmeeting,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = meetingSlice.actions;
export default meetingSlice.reducer;
